module.exports = "<p>\r\n  scroll-to-top works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// /home/maheshreddy/PRP_FE/src/app/scroll-to-top/scroll-to-top.component.html
// module id = ../../../../../src/app/scroll-to-top/scroll-to-top.component.html
// module chunks = main